import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { memo } from 'react';
import { FWBackline } from '../../logos/factionalwarfare/FWBackline.js';
import { FWSecondline } from '../../logos/factionalwarfare/FWSecondline.js';
import { FWFrontline } from '../../logos/factionalwarfare/FWFrontline.js';
import { FWSupport } from '../../logos/factionalwarfare/FWSupport.js';
var Symbols = memo(function (_ref) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("symbol", _objectSpread(_objectSpread({
      id: "backline-marker",
      viewBox: FWBackline.ViewBox
    }, props), {}, {
      children: /* @__PURE__ */jsx(FWBackline.Path, {})
    }), "backline-marker"), /* @__PURE__ */jsx("symbol", _objectSpread(_objectSpread({
      id: "secondline-marker",
      viewBox: FWSecondline.ViewBox
    }, props), {}, {
      children: /* @__PURE__ */jsx(FWSecondline.Path, {})
    }), "secondline-marker"), /* @__PURE__ */jsx("symbol", _objectSpread(_objectSpread({
      id: "frontline-marker",
      viewBox: FWFrontline.ViewBox
    }, props), {}, {
      children: /* @__PURE__ */jsx(FWFrontline.Path, {})
    }), "frontline-marker"), /* @__PURE__ */jsx("symbol", _objectSpread(_objectSpread({
      id: "support-marker",
      viewBox: FWSupport.ViewBox
    }, props), {}, {
      children: /* @__PURE__ */jsx(FWSupport.Path, {})
    }), "support-marker")]
  });
});
Symbols.displayName = "WarzoneMapSymbols";
export { Symbols };